<script lang="ts">
  import { browser } from '$app/environment';
  import type { EmbedPanelProps } from '$lib/types/contentTypes';

  export let embedPanel: EmbedPanelProps;
  let youtube = embedPanel.embedHtml?.match(/src=".+youtube\.com/);
  let instagram = embedPanel.embedHtml?.match(/data-instgrm-permalink=".+instagram\.com/);
  let tiktok = embedPanel.embedHtml?.match(/cite=".+tiktok\.com/);
  let facebook = embedPanel.embedHtml?.match(/src=".+facebook\.com/);
  let apple = embedPanel.embedHtml?.match(/src=".+podcasts.apple\.com/);
</script>

{#if browser}
  {#if youtube}
    <div class="sm:pb-8">
      <div class="block max-w-800 mx-auto">
        <div class="youtube relative pt:0 sm:pt-[56.25%] sm:mt-[-2rem]">
          {@html embedPanel.embedHtml}
        </div>
      </div>
    </div>
  {:else if instagram}
    <script
      async
      src="https://instagram.com/static/bundles/es6/EmbedSDK.js/47c7ec92d91e.js"
    ></script>
    <div class="!w-full block py-0 sm:py-8 overflow-hidden">
      {@html embedPanel.embedHtml}
    </div>
  {:else if tiktok}
    <div class="!w-full block py-0 sm:py-8 overflow-hidden">
      {@html embedPanel.embedHtml}
    </div>
    <script async src="https://www.tiktok.com/embed.js"></script>
  {:else if facebook}
    <div class="facebook !w-full h-[500px] sm:h-[600px] md:h-[690px] py-0 sm:py-8">
      {@html embedPanel.embedHtml}
    </div>
  {:else if apple}
    <div class="!w-full block py-0 sm:py-8 overflow-hidden">
      {@html embedPanel.embedHtml}
    </div>
  {/if}
{/if}

<style>
  :global(blockquote),
  :global(iframe) {
    margin: 0 auto !important;
    max-width: 500px !important;
    width: 100% !important;
  }
  :global(blockquote > iframe) {
    max-height: 100%;
    height: 100%;
  }
  :global(iframe[src*='facebook.com']) {
    height: 100%;
  }
  :global(iframe[src*='apple.com']) {
    background-color: transparent !important;
  }
  :global(div.max-w-800 > div.facebook) {
    height: 75vh !important;
  }

  @media only screen and (min-width: 600px) {
    :global(.relative iframe) {
      position: absolute;
      top: 2rem;
      left: 0;
      width: 100% !important;
      height: 100% !important;
      max-width: 100% !important;
    }
    :global(div.max-w-800 > div.facebook) {
      height: 950px !important;
    }
  }

  @media only screen and (min-width: 1200px) {
    :global(div.max-w-1280 > div.facebook) {
      height: 84vh !important;
    }
  }
</style>
